import { Component, HostListener, Input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Icône d’aide avec bulle (hover / focus / tap).
 * Contenu passé en texte déjà traduit ou via clé i18n {@link textKey}.
 */
@Component({
  selector: 'app-help-tip',
  templateUrl: './help-tip.component.html',
  styleUrls: ['./help-tip.component.css'],
  imports: [FaIconComponent, TranslateModule],
})
export class HelpTipComponent {
  /** Libellé déjà traduit. */
  @Input() text = '';

  /** Clé i18n alternative à {@link text}. */
  @Input() textKey = '';

  /** Libellé accessibilité du bouton (sinon texte d’aide). */
  @Input() label = '';

  open = false;

  get hasTextKey(): boolean {
    return !!this.textKey.trim();
  }

  toggle(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.open = !this.open;
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.open = false;
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.open = false;
  }
}
